import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LoginForm from '@/components/auth/LoginForm'
import { useIsAuthenticated } from '@/store/authStore'
import { ROUTE_PATHS } from '@/utils/constants'
import { Card, CardBody } from '@/components/common'

export default function LoginPage() {
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  // Redirect to balance if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTE_PATHS.BALANCE, { replace: true })
    }
  }, [isAuthenticated, navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)]">
      <Card className="w-full max-w-[450px]">
        <CardBody className="p-8">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="flex justify-center mb-4">
              <svg
                className="w-12 h-12 text-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-text">RSUI Payment Portal</h2>
          </div>

          <div className="border-t border-border my-4" />

          {/* Login Form */}
          <LoginForm />

          <div className="border-t border-border my-6" />

          {/* About Section */}
          <div className="text-center">
            <h3 className="text-sm font-semibold text-text mb-2">About This Portal</h3>
            <p className="text-sm text-text-muted leading-relaxed">
              This secure portal allows you to pay insurance deductibles and audit premiums online.
            </p>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
